import { render, staticRenderFns } from "./TextHeadlineSecondary.vue?vue&type=template&id=632156ac&scoped=true&"
var script = {}
import style0 from "./TextHeadlineSecondary.vue?vue&type=style&index=0&id=632156ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632156ac",
  null
  
)

export default component.exports